<template>
  <div class="card">
    <no-active-polls v-if="!areActivePolls && !isDedicated" />
    <div v-if="activeQuestionExists">
      <h2>{{ $t('HOME.LIVE_QUESTIONS') }}</h2>
      <div
        class="list-entry"
        @click="goToQuestion(activeQuestion.pollId, activeQuestion.questionId)"
      >
        <span class="live blink">LIVE</span>
        <span class="live-question">{{ activeQuestion.texts[lang] }}</span>
      </div>
    </div>

    <h2 v-if="asyncPolls.length > 0">{{ $t('HOME.SURVEY_LIST') }}</h2>
    <poll-list :polls="asyncPolls" @onPollClick="goToPoll" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'ramda';
import PollList from '@/components/polls/PollList';
import NoActivePolls from '@/components/polls/NoActivePolls';

export default {
  name: 'home',
  components: {
    PollList,
    NoActivePolls
  },
  computed: {
    ...mapGetters({ asyncPolls: 'asyncPolls', activeQuestion: 'activeQuestion', lang: 'getInputLanguage' }),
    activeQuestionExists() {
      return !isEmpty(this.activeQuestion);
    },
    areActivePolls() {
      return this.activeQuestionExists || !isEmpty(this.asyncPolls);
    }
  },
  methods: {
    ...mapGetters(['isDedicated']),
    goToPoll(pollId) {
      this.$router.push({
        name: 'pollContent',
        params: {
          pollId
        }
      });
    },

    goToQuestion(pollId, questionId) {
      this.$router.push({
        name: 'questionContent',
        params: {
          pollId,
          questionId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blink {
  animation: blink-animation 1s infinite alternate;
}
@keyframes blink-animation {
  to {
    background-color: #36e786;
  }
}
.live {
  padding: 1px 7px;
  background-color: #1fd16f;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  vertical-align: baseline;
  border: 1px solid #fff;
  border-radius: 9px;
}
.live-question {
  margin-left: 5px;
}
</style>
